import $ from 'jquery'
import { prepareChessboard, loadNextConfiguration, validateDrag, validateDrop } from '../../utils';
import ChessBoard from '../../components/chessBoard';

/**
* @name lesson10Assignment1
* @function
* @param {config}
* @description: activity related task
*/
export function lesson10Assignment1(config) {

  let callback = function () {
    let body = `
      <div class="card flex-center">
        <div class="card-wrapper full-width">
          <ul class="options-table">
            <li class="table-row flex-vertical-center" index="0"><span class="answer-img"></span><span class="answer">This piece only travels on diagonal lines</span></li>
            <li class="table-row flex-vertical-center" index="1"><span class="answer-img"></span><span class="answer">This piece is the most powerful</span></li>
            <li class="table-row flex-vertical-center" index="2"><span class="answer-img"></span><span class="answer">This piece can jump over other pieces</span></li>
            <li class="table-row flex-vertical-center" index="3"><span class="answer-img"></span><span class="answer">If you trap this piece then you win</span></li>
            <li class="table-row flex-vertical-center" index="4"><span class="answer-img"></span><span class="answer">This piece moves and captures differently</span></li>
            <li class="table-row flex-vertical-center" index="5"><span class="answer-img"></span><span class="answer">This piece is part of a castle</span></li>
          </ul>
        </div>
      </div>`;

    $('.activity-section-content').html(body);
  }
  return callback;
}

/**
* @name dragDropPieces
* @function
* @param {config}
* @description: Drag and drop the pieces in to the board
*/
export function dragDropPieces(config) {
  let next = config.next,
    validatePieces = config.validatePieces ? config.validatePieces : [],
    pieceLimit = config.pieceLimit;

  let afterLoad = function () {
    prepareChessboard(config);
  }

  let onDragStart = function (source, piece, position, orientation) {
    validateDrag(piece, pieceLimit[piece])
    
  };

  let onDrop = function (source, target, piece, newPos, oldPos, orientation) {
    return validateDrop(piece, pieceLimit[piece], target, validatePieces, true)
  }

  var onSnapEnd = function (source, target, piece) {
    if (config.resultFen === ChessBoard.board.fen()) {
      loadNextConfiguration(2000, next, true)
    }
  }

  const chessConfig = {
    config: {
      draggable: true,
      dropOffBoard: 'trash',
      sparePieces: true,
      onDrop: onDrop,
      onDragStart: onDragStart,
      onSnapEnd: onSnapEnd,
      pieceTheme: `img/chesspieces/${config.pieceTheme}/{piece}.svg`
    },
    afterLoad: afterLoad
  }
  return chessConfig;
}



/**
* @name lesson10Assignment2
* @function
* @param {config}
* @description: chess board related task
*/
export function lesson10Assignment2(config) {
  let next = config.next,
    moveCount = 0;
  
  let afterLoad = function () {
    prepareChessboard(config);
  }

  var onSnapbackEnd = function(piece, square, position, orientation) {
    ChessBoard.game = new window.Chess(config.position + config.startChance);
  };

  var onSnapEnd = function (source, target, piece) {
  }

  let onDrop = function (source, target, piece, newPos, oldPos, orientation) {
    let move = ChessBoard.game.move({
      from: source,
      to: target,
    });

    if (piece.search("K") === -1 && piece.search("R") === -1) {
      return 'snapback'
    }

    if (piece.search("R") !== -1 && target === config.rookTarget) {
      // continue
    } else if (piece.search("R") !== -1 && move === null) {
      return 'snapback'      
    }

    if (piece.search("K") !== -1 && target === config.kingTarget) {
      // continue
    } else if (piece.search("K") !== -1 && move === null) {
      return 'snapback'      
    }
    
    moveCount = moveCount + 1;
    
    if (moveCount === 2) {
      if (window.ChessBoard.objToFen(newPos) !== config.finalPosition) {
        moveCount = 0;
        ChessBoard.board.position(config.position);
        return 'snapback'
      } else {
        moveCount = 0;
        loadNextConfiguration(2000, next, true)
      }
    }
  }

  const chessConfig = {
    config: {
      position: config.position,
      onDrop: onDrop,
      onSnapEnd: onSnapEnd,
      onSnapbackEnd: onSnapbackEnd,
      draggable: true,
      sparePieces: true
    },
    afterLoad: afterLoad
  }
  return chessConfig;
}


/**
* @name lesson10Assignment3
* @function
* @param {config}
* @description: chess board related task
*/
export function lesson10Assignment3(config) {
  let afterLoad = function () {
    prepareChessboard(config);
    ChessBoard.board.position(config.finalPosition);
  }
  
  const chessConfig = {
    config: {
      position: config.position,
      moveSpeed: 1000
    },
    afterLoad: afterLoad
  }
  return chessConfig;
}


// WEBPACK FOOTER //
// ./src/lessons/lesson_10/assignments.js